import React from 'react';
import { Box, SxProps, useTheme } from '@mui/material';
import { Link } from '@tanstack/react-router';

export enum DisclaimerType {
  ACCEPTABLE_USE_POLICY = 'ACCEPTABLE_USE_POLICY',
  PRODUCT_OUTPUT_DISCLAIMER = 'PRODUCT_OUTPUT_DISCLAIMER',
}

const disclaimerConfig = {
  [DisclaimerType.ACCEPTABLE_USE_POLICY]: {
    text: 'Acceptable Use Policy',
    url: 'https://help.zscaler.com/legal/acceptable-use-policy',
  },
  [DisclaimerType.PRODUCT_OUTPUT_DISCLAIMER]: {
    text: 'Product Output Disclaimer',
    url: 'https://help.zscaler.com/legal/product-output-disclaimer',
  },
};

interface CopilotDisclaimerProps {
  sx?: SxProps;
  type?: DisclaimerType;
}

const CopilotDisclaimer = ({ sx, type = DisclaimerType.ACCEPTABLE_USE_POLICY }: CopilotDisclaimerProps) => {
  const { text, url } = disclaimerConfig[type];

  return (
    <Box
      sx={{
        textAlign: 'center',
        alignSelf: 'center',
        textDecoration: 'underline',
        width: 'fit-content',
        fontSize: 12,
        color: theme => theme.palette.colors.neutrals[600],
        ':hover': { color: theme => theme.palette.colors.primary[500] },
        ...sx,
      }}
      component={Link}
      to={url}
      target="_blank">
      {text}
    </Box>
  );
};

export default CopilotDisclaimer;

export const AiInteractionDisclaimer = () => {
  const theme = useTheme();
  return (
    <Box sx={{ width: '100%', px: 3, pb: 2 }}>
      <Box
        sx={{
          fontSize: '12px',
          border: theme => `1px solid ${theme.palette.colors.neutrals[350]}`,
          p: 1,
          borderRadius: '12px',
          backgroundColor: 'var(--color-background-primary)',
        }}>
        {`You are interacting with an AI Chatbot. It is a machine learning model, and its responses may be incomplete or inaccurate.
      Please refer to Zscaler's `}
        <CopilotDisclaimer sx={{ color: theme.palette.colors.primary[500] }} /> and{' '}
        <CopilotDisclaimer sx={{ color: theme.palette.colors.primary[500] }} type={DisclaimerType.PRODUCT_OUTPUT_DISCLAIMER} />
      </Box>
    </Box>
  );
};
